import { render, staticRenderFns } from "./managerRemindList.vue?vue&type=template&id=6fa9cdd1&scoped=true"
import script from "./managerRemindList.vue?vue&type=script&lang=js"
export * from "./managerRemindList.vue?vue&type=script&lang=js"
import style0 from "./managerRemindList.vue?vue&type=style&index=0&id=6fa9cdd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9cdd1",
  null
  
)

export default component.exports